/**
 * Represents authorized permissions a user can take.
 */
export enum Action {
  /**
   * The user may view content on a board.
   */
  read = 'read',
  /**
   * The user may edit, add and delete content on a board.
   */
  write = 'write',
  /**
   * The user may create new boards.
   */
  create = 'create',
  /**
   * The user is an administrator for an Atlassian site.
   * @description Used for standalone mode only, not embedded mode.
   * @deprecated No longer used
   */
  manage = 'manage',
  /**
   * User can add comments to this whiteboard
   */
  'add/comment' = 'add/comment',
  /**
   * User can remove comments from this whiteboard
   */
  'delete/comment' = 'delete/comment',
}

export const isAction = (action: any): action is Action => {
  return typeof action === 'string' && action in Action;
};

/**
 * Returns a compact string representation of the current permissions a user has.
 * @example read -> r
 * @example read, write -> rw
 * @example empty -> -
 * @param actions
 * @returns string summary of current user permissions
 */
export const compact = (actions: Set<Action> | Array<Action>) => {
  let str = '';

  for (const action of actions) {
    if (action === Action.read) {
      str += 'r';
    }
    if (action === Action.write) {
      str += 'w';
    }
    if (action === Action.create) {
      str += 'c';
    }
    if (action === Action['add/comment']) {
      str += 'ac';
    }
    if (action === Action['delete/comment']) {
      str += 'dc';
    }
  }

  if (str.length === 0) {
    return '-';
  }
  return str;
};
